import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';

@Component({
    selector: 'app-cart-additional-info',
    templateUrl: './cart-additional-info.page.html',
    styleUrls: ['./cart-additional-info.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CartAdditionalInfoPage implements OnInit {

    special_instructions = "";
    customer_note = "";
    internal_note = "";
    cart = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService

    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {

            this.cart = cart;

            if(cart['special_instructions']) {
                this.special_instructions = cart['special_instructions'];
            }
            if(cart['customer_note']) {
                this.customer_note = cart['customer_note'];
            }
            if(cart['internal_note']) {
                this.internal_note = cart['internal_note'];
            }

        });

    }

    close() {
        this.modalController.dismiss();
    }

    async update() {

        if(this.special_instructions != this.cart['special_instructions']) {
            await this.cartService.updateSpecialInstructions(this.special_instructions).then(() => {}).catch(() => {});
        }
        if(this.customer_note != this.cart['customer_note']) {
            await this.cartService.updateCustomerNote(this.customer_note).then(() => {}).catch(() => {});
        }
        if(this.internal_note != this.cart['internal_note']) {
            await this.cartService.updateInternalNote(this.internal_note).then(() => {}).catch(() => {});
        }

        this.modalController.dismiss();

    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

}
